class ManuallyConfirmationStatusType {
  None() {
    return 'None';
  }
  NoNeed() {
    return 'NotRequired';
  }
  ReadyToAccept() {
    return 'NotConfirmed';
  }
  Accepted() {
    return 'Confirmed';
  }
}
export default new ManuallyConfirmationStatusType();

